import React from 'react';


// todo: it would be good to remove the forwardRef as this should be a simmple leaf component
// it is currently being used by app.js:
/**
 * window.addEventListener('loading', () => {
	if (!this._firstLoad) {
		this._loadIconRef.current.classList.remove('hidden');
	}
	this._firstLoad = false;
});
 * We should be able to simply add / remove 'hidden' class by passing a 'loading' state - task #3187.
 */

const Loading = React.forwardRef((_, ref) => (
	<div className='load-icon hidden' ref={ref}>
		{
			[
				'bg',
				'front',
				'left',
				'top',
				'right',
				'bottom'
			].map((face, index) => (
				<div key={index} className={face + ' face'} />
			))
		}
		<div className='text'>جار التحميل</div>
	</div>
));

Loading.displayName = 'Loading';

export default Loading;
